import { sidebarConstants as sc } from 'srcReact/components/common2/Navigation/SideBarMain/constant'

const initialState = {
  sidebarUrl: {},
  createPostPopup: false
}

export function sideBar(state = initialState, action) {
  switch (action.type) {
    case sc.CREATE_POST_POPUP:
      return {
        ...state,
        createPostPopup: action.value
      }

    default:
      return state
  }
}
